export default __webpack_public_path__ + "58ce758b3f6775d6deaaa5482bed4d10.glb";